import { useForm } from "react-hook-form";
import * as yup from "yup";

export type BeachFormType = {
  id?: string;
  name?: string;
  lat: number;
  lng: number;
  city?: string;
  minBookingTime?: number;
  maxBookingTime?: number;
  bookingTimeLimit?: number;
  peoplePerSeat?: number;
  openingTime?: string;
  closingTime?: string;
  rows?: number;
  seatsPerRow?: number;
  accountType?: string;
};

const validationSchema = yup.object<BeachFormType>().shape<BeachFormType>({
  id: yup.string(),
  name: yup.string().required("Campo obbligatorio"),
  lat: yup.number().required(),
  lng: yup.number().required(),
  bookingTimeLimit: yup.number().required(),
  peoplePerSeat: yup.number(),
  openingTime: yup.string(),
  closingTime: yup.string(),
  seatsPerRow: yup.number(),
});

const useFormBeach = (initialValues?: BeachFormType) => {
  const form = useForm<BeachFormType>({
    defaultValues: initialValues,
    validationSchema,
  });
  return form;
};

export default useFormBeach;
